
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Header from './Components/Common/Header';
import Footer from './Components/Common/Footer';
import Home from './Components/Home';
import Aboutus from './Components/Aboutus';
import Service from './Components/Service';
import ContactUs from './Components/Common/ContactUs';
import ServicesDetails from './Components/ServicesDetails';
import Blog from './Components/Blog';
import BlogPage1 from './Components/BlogPages/BlogPage1';
import SoftwareDevelopment from './Components/Services/SoftwareDevelopment';
import CyberSecurity from './Components/Services/CyberSecurity';
import QAServices from './Components/Services/QAServices';
import CloudServices from './Components/Services/CloudServices';
import ArtificialIntelligence from './Components/Services/ArtificialIntelligence';
import Careers from './Components/Careers';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/About-Us' element={<Aboutus />} />
        <Route path='/Service' element={<Service />} />
        <Route path='/Contact-Us' element={<ContactUs />} />
        <Route path='/Services-Details' element={<ServicesDetails />} />
        <Route path='/Blog' element={<Blog />} />
        <Route path='/BlogPage' element={<BlogPage1 />} />
        <Route path='/Careers' element={<Careers />} />

        <Route path='/Software-Development' element={<SoftwareDevelopment />} />
        <Route path='/Cyber-Security' element={<CyberSecurity />} />
        <Route path='/QA-Services' element={<QAServices />} />
        <Route path='/Cloud-Services' element={<CloudServices />} />
        <Route path='/Artificial-Intelligence' element={<ArtificialIntelligence />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
